import InputField from './inputField';

class Module extends InputField {
  setupDefaults() {
    super.setupDefaults();

    const observer = new window.MutationObserver(mutations => {
      mutations.forEach(({ attributeName }) => {
        if (attributeName === 'class') {
          this.handleInputValidation();
        }
      });
    });
    observer.observe(this.dom.input, { attributes: true });

    this.handleInputValidation();
  }

  handleInputValidation() {
    if (this.dom.input.classList.contains('input-validation-error')) {
      this.el.classList.add('form-input--error');
    } else {
      this.el.classList.remove('form-input--error');

      if (this.dom.input.value) {
        this.el.classList.add('form-input--valid');
      } else {
        this.el.classList.remove('form-input--valid');
      }
    }
  }
}

export default Module;
